import { isDevMode } from '@angular/core';
import {
  addIntegration,
  consoleLoggingIntegration,
  init,
  lazyLoadIntegration,
} from '@sentry/angular';

export interface SentryOptions {
  dsn: string;
  /** Share of sessions recorded with a replay. Sessions with an error are always recorded. */
  replaysSessionSampleRate?: number;
}

/**
 * Initializes Sentry, except in development mode. Must be called before the
 * application is bootstrapped.
 *
 * Personal data is not sent by default: no IP address or cookies, and replays
 * mask texts, inputs and media.
 */
export function initSentry({ dsn, replaysSessionSampleRate = 0 }: SentryOptions): void {
  // Errors from local development must not reach the production projects.
  if (isDevMode()) {
    return;
  }

  init({
    dsn,
    enableLogs: true,
    integrations: [
      // send console.warn and console.error calls as logs to Sentry
      consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    replaysSessionSampleRate,
    replaysOnErrorSampleRate: 1.0,
  });

  // Enable session replays via CDN lazy-load (keeps ~127 kB out of the initial bundle).
  lazyLoadIntegration('replayIntegration')
    .then((replayIntegration) => addIntegration(replayIntegration()))
    .catch(() => {
      // Replay is optional - ignore CDN load failures
    });
}
